export default "https://cdn-static.gokick.com/assets/dbba9902646848f8f0b834a64aaa98666d1f7693/images/spearmint-flavor.4c44d265d2ca14e44f653db82c437465.png";